import axios from "axios";
import { createToast } from "../components/Toast";
import { MessageKind } from "./common";
import { ENV } from "./const";
import { handleSessionExpired, isSessionExpiredResponse } from "./session";

export const sendErrorToH2E = async (ev: ErrorEvent) => {
    if(ENV === "local"){ return }
    try {
        const error = {
            message: ev.message,
            stack: ev.error.stack,
            location: {
                href: window.location.href,
                pathname: window.location.pathname,
            },
            filename: ev.filename,
            lineno: ev.lineno,
            colno: ev.colno
        }


        await axios.post(
            `https://hook2email.com/api/hooks/19eb8280-f3c1-4790-8fc3-88b1da7c44bb/send`,
            { error: JSON.stringify(error) },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
    } catch (e) { }
}

export const handleApiError = async (response: Response, t: any, relogin: boolean = false) => {
    if (await isSessionExpiredResponse(response)) {
        await handleSessionExpired();
        return;
    }
    const error = await response.json();
    let msg = ""
    if( typeof error.message === "string") {
        msg = error.message
    } else if (typeof error.detail === "string") {
        msg = error.detail
        console.log(msg, relogin)
        if(relogin && msg === "Credentials missing") {
            window.location.reload()
        }
    } else {
        msg = t("common.internal-server-error")
    }
    createToast(msg, MessageKind.Error);
}

export const getSearchParam = (name: string): string | null => {
    const params = new URLSearchParams(window.location.search)
    return params.get(name)
}